import React, {
  memo, useState, useEffect,
} from 'react';
import Button from '@active/react-ui/Button';
import Locale from '@active/react-utils/i18n/Locale';
import { bool, number, string } from 'prop-types';
import { useSelector } from 'react-redux';
import ConnectStatus from './components/ConnectStatus';
import CheckEndorseModal from './components/CheckEndorseModal';
import { useCheckScanner } from './hooks/useCheckScanner';
import { CONNECTSTATUS } from './config';
import { CheckScannerModal } from './components/CheckScannerModal';
import { CheckImageModal } from './components/CheckImageModal';
import { formatPrintEndorsementContent } from './utils/formatPrintEndorsementContent';

const CheckScanner = (props) => {
  const { endorsementContent, disableBtn, checkPaidAmount } = props;

  const {
    entities: {
      orderInfo: {
        businessDate: {
          timeZoneOffset,
        } = {},
        currencyCode,
        totalAmount,
      },
    },
  } = useSelector(state => state?.mainStateData);

  const {
    locale,
  } = useSelector((state) => {
    return state.propsData;
  });
  const {
    status, processDocument, getDeviceList, errorInfo,
    showModal,
    showImageModal,
  } = useCheckScanner();

  const [ isShowCheckEndorseModal, setIsShowCheckEndorseModal ] = useState(false);

  useEffect(() => {
    getDeviceList();
  }, [ getDeviceList ]);

  const handleCheckEndorseModalClose = () => {
    setIsShowCheckEndorseModal(false);
  };

  const handleCheckEndorse = (shouldPrintEndorse) => {
    setIsShowCheckEndorseModal(false);
    const printedEndorse = shouldPrintEndorse ? formatPrintEndorsementContent(endorsementContent, {
      totalAmount: checkPaidAmount || totalAmount, currencyCode, timeZoneOffset,
    }, locale) : '';
    processDocument({ endorsementContent: printedEndorse });
  };

  const handleScan = () => {
    if (endorsementContent) {
      setIsShowCheckEndorseModal(true);
    } else {
      processDocument({ endorsementContent });
    }
  };

  return <div className="check-scanner">
    <ConnectStatus status={status} errorInfo={errorInfo} />
    {status === CONNECTSTATUS.connect && <div className="scan-btn-box">
      <Button type="primary" onClick={handleScan} className="check-scan" disabled={disableBtn}>
        <Locale id="checkout.lib.components.payment.check.scan" />
      </Button>
    </div>}
    {isShowCheckEndorseModal
      && <CheckEndorseModal
        handleCheckEndorseModalClose={handleCheckEndorseModalClose}
        handleCheckEndorse={handleCheckEndorse} />}
    {showModal && <CheckScannerModal />}
    {showImageModal && <CheckImageModal />}
  </div>;
};

CheckScanner.propTypes = {
  endorsementContent: string.isRequired,
  disableBtn: bool,
  checkPaidAmount: number,
};

CheckScanner.defaultProps = {
  endorsementContent: '',
  disableBtn: false,
};

export default memo(CheckScanner);
